import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ListUsers from '../../components/Users/ListUsers';
import { getUsers } from '../../store/actions/users/users.action';
import PageLoader from '../../components/Common/PageLoader';
import { getSubscriptions } from '../../store/actions/subscription/subscription.action';

import '../../styles/users.css';

const UsersListContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const users = useSelector((state) => state.users.list);
  const isFetching = useSelector((state) => state.users.isFetching);
  const categories = useSelector((state) => state.auth.categories);
  const pagination = useSelector((state) => state.users.pagination);
  const subscriptions_list = useSelector((state) => state.subscription.list);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const userCategory = categories.find((category) => category.link === 'users');
      if (userCategory) {
        setMode(userCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('User category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Initialize on mount
  useEffect(() => {
    dispatch(getUsers(1, 10e9));
    dispatch(getSubscriptions());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  return (
    <section id="users-list">
      <ListUsers
        mode={mode}
        usersInfo={users}
        subscriptions_list={subscriptions_list}
      />
    </section>
  );
};

export default UsersListContainer;
